import { AccessSessionClientModel, AccessSessionsGroupClientModel } from '@client-app-sdk';
import { AccessGroupIcon } from '@MyAccess/organisms/AccessSessionGroupList';

export function getGroupIcons(group: AccessSessionsGroupClientModel) {
  const icons: Record<string, AccessGroupIcon> = {};
  group.sessions.forEach((session: AccessSessionClientModel) => {
    if (!icons[session.type.icons.svg])
      icons[session.type.icons.svg] = { svg: session.type.icons.svg, alt: session.type.name };
  });
  return Object.values(icons);
}
